<template>
  <a-modal
    title="修改密码"
    centered
    :width="640"
    :mask-closable="false"
    :visible="showPasswordForm"
    :confirmLoading="loading"
    @cancel="close"
  >
    <a-form-model
      ref="form"
      :model="model"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      >
        <a-spin :spinning="loading">
          <a-form-model-item label="原始密码" prop="password_original">
            <a-input-password v-model="model.password_original" autocomplete="off"/>
          </a-form-model-item>
          <a-form-model-item label="新密码" prop="password">
            <a-input-password v-model="model.password" autocomplete="off"/>
          </a-form-model-item>
          <a-form-model-item label="确认密码" prop="password_confirmation">
            <a-input-password v-model="model.password_confirmation" autocomplete="off"/>
          </a-form-model-item>
        </a-spin>
      </a-form-model>

    <template slot="footer">
      <a-button @click="close" :disabled="loading">取消</a-button>
      <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
    </template>
  </a-modal>
</template>

<style lang="less" scoped>
@import 'Password';
</style>

<script>
import Password from './Password'
export default Password
</script>
